import * as variables from './variables.js';
import passiveIfSupported from "./lib/passiveIfSupported";

import "./site/Analytics";

import './lib/AnimationEasing';

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import SearchForm from './component/HeaderSearchForm';
new SearchForm('.searchArea', '.searchArea__icon', '.searchArea__query', 'open');

import Forms from './component/Forms';
Forms.init();

import Gallery from './component/Gallery';
new Gallery();

let weAreInIE11Hell = false;
// Function to make IE9+ support String.includes:
if (!String.prototype.includes) {
	// @ts-ignore
	String.prototype.includes = function(substr) {
		return this.indexOf(substr) >= 0;
	}
	weAreInIE11Hell = true;
}

// Function to make IE9+ support forEach:
if (window.NodeList && !NodeList.prototype.forEach) {
	// @ts-ignore
	NodeList.prototype.forEach = Array.prototype.forEach;
	weAreInIE11Hell = true;
}

// @ts-ignore
// var Accordion = require('./component/Accordion.js');
// var faqsAccordion = new Accordion({
// 	scope: '.job'
// });
// faqsAccordion.activate();

import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup();

/* Basic Carousels */
import Carousel from './Carousel';

const setUpFeatureCarousels = () => {
	const featureCarousels = document.querySelectorAll('body .carousel:not([data-carousel-set-up="true"])');
	for (let i = 0; i < featureCarousels.length; i++) {
		const featureCarousel = featureCarousels.item(i);
		if (featureCarousel) {
			featureCarousel.setAttribute('data-carousel-set-up', 'true');
			new Carousel({
				analyticsCategory: 'Feature Carousel',
				carouselEl: featureCarousel as HTMLElement,
				duration: 8000,
				allowIndicatorClick: false,
				autoAdvance: false,
				autoHeight: true,
				progressEl: document.getElementById('featureCarousel-indicator')
			});
		}
	}
};
setUpFeatureCarousels();
document.addEventListener('jsfAjaxEvent', event => {
	if ((event as any).detail.fireType === 'always') {
		setUpFeatureCarousels();
	}
});

/* Silky smooth scrolling for local nav on property pages (about, floor plan, etc.) */
import SmoothScroll from './component/SmoothScroll';
const mySmoothScroll = new SmoothScroll();
mySmoothScroll.add('a[class*="nav__link"][href*="#"]:not([onclick]), .contentBlocks__menu a[href*="#"]:not([onclick]), .floorPlan__link a[href*="#"]:not([onclick])', {
	duration: 1500,
	easing: 'easeInOutQuad',
	offset: 100
});

// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;
import 'jquery-colorbox';

import Colorbox from './component/Colorbox'
new Colorbox();

import VideoLightbox from './component/VideoLightbox';
VideoLightbox();

import SavedPropertiesManager from './component/SavedPropertiesManager';
$().ready(() => {
	SavedPropertiesManager.init();
});
(window as any).SavedPropertiesManager = SavedPropertiesManager;


// Sticky code
const stickyActiveStyleClass = "stickyElement--isActive";
const stickyElem = document.getElementsByClassName("stickyElement"); // Returns a live collection
const updateStickElements = () => {
	for (let i = 0; i < stickyElem.length; i++) {
		const elem = stickyElem[i] as HTMLElement;

		const stickyMode = elem.getAttribute("data-stickyElement-mode");


		const container = elem.parentElement;
		const containerBCR = container.getBoundingClientRect();
		const elemBCR = elem.getBoundingClientRect();

		if (stickyMode === "follow") {
			let positionToParent = elem.getAttribute("data-stickyElement-positionToParent");
			if (positionToParent === null) {
				// Is it closer to the top and bottom
				positionToParent =
					(elemBCR.top - containerBCR.top <=  containerBCR.bottom - elemBCR.bottom)
						? "top"
						: "bottom";
				elem.setAttribute("data-stickyElement-positionToParent", positionToParent);
			}

			if (
				(positionToParent === "bottom" && containerBCR.bottom - elemBCR.height <= 0)
				|| (positionToParent === "top" && containerBCR.top <= 0)
			) {
				elem.classList.add(stickyActiveStyleClass);
			} else {
				elem.classList.remove(stickyActiveStyleClass);
			}
		} else if (stickyMode === "stickyToParent") {
			const elemFitsOnScreen = elemBCR.height < (window.innerHeight || window.document.documentElement.clientHeight);

			if(containerBCR.top <= 0 && elemFitsOnScreen) {
				elem.classList.add(stickyActiveStyleClass);
			} else {
				elem.classList.remove(stickyActiveStyleClass);
			}
		}
	}
}
window.addEventListener("scroll", updateStickElements, passiveIfSupported);
window.addEventListener("resize", updateStickElements, passiveIfSupported);
updateStickElements(); // Call once.


function getWidth() {
	return Math.max(
		document.body.scrollWidth,
		document.documentElement.scrollWidth,
		document.body.offsetWidth,
		document.documentElement.offsetWidth,
		document.documentElement.clientWidth
	);
}

import propertyCarousel from './component/propertyCarousel';
propertyCarousel();

import CompareManager from "./component/CompareManager";
CompareManager.init();

import AutoCompleter from "./component/AutoCompleter";
AutoCompleter();

import AccessibleDropdown from "./component/AccessibleDropdown";
AccessibleDropdown('.accessibleDropdown', 'active', 'mobile');

import {default as mapControllerInitializer} from './component/MapController';
mapControllerInitializer();

import {default as propertySearchPageInitializer} from './component/PropertySearchPage';
if (document.querySelector("body.page--properties")) {
	propertySearchPageInitializer();
}

// Leadership Team Bios
import TeamLanding from './component/TeamLanding';
new TeamLanding({
	team: '.teamListing',
	styleClass: {
		items: '.teamListing__item',
		links: '.teamMember__fullLink',
		bios: '.teamListing__bio'
	}
});

import {default as AjaxPage, AjaxPageLinkManager, LoadState as AjaxPageLoadState} from "./component/AjaxPage";
const linkManager = AjaxPageLinkManager.getInstance();
linkManager.addConfig(
	".propertyListing .ajaxPageLink",
	{
		closeButtonText: "Back to Properties"
	}
);
linkManager.addConfig(
	".propertyComparison .ajaxPageLink",
	{
		closeButtonText: "Back to Comparison"
	}
);

// Advanced Option Search - Toggle 'Active' class
$(function() {
	$(document).on("click", ".searchToggle", () => {
		$(".propertyListing__filterForm, .searchToggle").toggleClass("open");
	});
});

// Home Page - Tab/Form Toggle
$(function() {
	$(document).on("click", ".tab", () => {
		$(".tab--property").toggleClass("active");
		$(".tab--resident").toggleClass("active");
		$(".masthead__form--property").toggleClass("active");
		$(".masthead__form--resident").toggleClass("active");
	});
});

// I loathe IE11 with a burning passion
if (weAreInIE11Hell) {
	const weCannotUseStyleLazySoWeAreDoomed: MutationCallback = ((mutations) => {
		for (let i = 0; i < mutations.length; i++) {
			const addedNodes = mutations[i].addedNodes;
			for (let j = 0; j < addedNodes.length; j++) {
				const addedNode = addedNodes.item(j) as HTMLElement;
				if (typeof addedNode.hasAttribute === "function" && addedNode.hasAttribute("style-lazy")) {
					addedNode.setAttribute("style", addedNode.getAttribute("style-lazy"));
					addedNode.removeAttribute("style-lazy");
				}
			}
		}
	});

	document.querySelectorAll("[style-lazy]").forEach(item => {
		if (item.hasAttribute("style-lazy")) {
			item.setAttribute("style", item.getAttribute("style-lazy"));
			item.removeAttribute("style-lazy");
		}
	});
	new MutationObserver(weCannotUseStyleLazySoWeAreDoomed).observe(document.body, {attributes: false, childList: true, subtree: true});
} else {
	// @ts-ignore
	const ViewportChecker = require('viewport-checker');
	const makeAndAttachVPC = (scrollBoxSelector: Window | string, trackedElementSelector: string, scrollHorizontally: boolean = false) => {
		const trackedElementPrefix = scrollBoxSelector === window ? '' : scrollBoxSelector + ' ';
		if (document.querySelector(trackedElementPrefix + trackedElementSelector) !== null) {
			const vpc = new ViewportChecker(trackedElementPrefix + trackedElementSelector, {
				classToAdd: 'visible',
				classToAddForFullView: 'full-visible',
				classToRemove: 'invisible',
				removeClassAfterAnimation: false,
				offset: '-20%',
				invertBottomOffset: true,
				repeat: false,
				animated: false,
				scrollHorizontally: scrollHorizontally,
				scrollBox: scrollBoxSelector,
				callbackFunction: function (elem: HTMLElement, action: any) {
					if (action === 'add') {
						elem.setAttribute('style', elem.getAttribute('style-lazy'));
						elem.removeAttribute('style-lazy');
					}
				}
			});
			if (!(window as any).viewportCheckers) {
				(window as any).viewportCheckers = [];
				document.addEventListener('jsfAjaxEvent', () => {
					((window as any).viewportCheckers as Array<any>).forEach(vpc => {
						vpc.detach();
						vpc.attach();
						vpc.check();
					});
				});
			}
			((window as any).viewportCheckers as Array<any>).push(vpc);
			document.addEventListener('DOMContentLoaded', () => vpc.attach());
		}
	}

	makeAndAttachVPC('.propertyListing__itemsWrapper', '[style-lazy]');
	makeAndAttachVPC('.comparisonBar', '[style-lazy]', true);
}
